import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { authenticationService } from "../../services/authentication.service";
import { Localization } from "../common/Localization";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { appController } from "../../controllers/app.controller";
import { Form, Field } from "react-final-form";
import GlobalContext from "../../GlobalContext";

class Login extends Component {
    constructor(props, context) {
        super(props, context);

        // redirect to home if already logged in
        if (authenticationService.currentUserValue) {
            this.props.history.push("/");
        }

        this.state = {
            sklady: [],
            loading: true,
            username: null,
            password: null,
            sklad: authenticationService.currentSklad,
            submitted: false,
            errorMessage: null
        };

        var selectedLanguage = localStorage.getItem("selectedLanguage");
        if (selectedLanguage !== null) {
            this.context.changeLanguage(selectedLanguage);
        }
    }

    displayName = Login.name;

    componentDidMount() {
        appController.getSklady().then(ajaxData => {
            let data = JSON.parse(JSON.stringify(ajaxData));
            sessionStorage.setItem("sklady", JSON.stringify(data));
            this.setState({
                sklady: data.filter(el => {
                    return el.typSkladu === 2;
                }),
                loading: false
            });
        });
    }

    onValidation(values) {
        var localizationService = provideLocalizationService(this);
        const errors = {};

        if (!values.sklad) {
            errors.sklad = localizationService.toLanguageString("LoginPage.Položka Predajňa je povinná.", "Položka Predajňa je povinná.");
        }

        if (!values.username) {
            errors.username = localizationService.toLanguageString("LoginPage.Položka Užívateľské meno je povinná.", "Položka Užívateľské meno je povinná.");
        }

        if (!values.password) {
            errors.password = localizationService.toLanguageString("LoginPage.Položka Heslo je povinná.", "Položka Heslo je povinná.");
        }

        return errors;
    }

    onSubmit(values) {
        var button = document.getElementsByClassName("login-button")[0];
        button.disabled = true;
        this.setState({ ...values, submitted: true });
        authenticationService.login(values.username, values.password, values.sklad).then(user => {
            if (user.errorMessage) {
                button.disabled = false;
                this.setState({ ...values, submitted: false, errorMessage: user.errorMessage });
            } else {
                const { from } = this.props.location.state || { from: { pathname: "/" } };
                this.props.history.push(from);
            }
        });
    }

    render() {
        const { errorMessage } = this.state;
        var localizationService = provideLocalizationService(this);

        return (
            <div className="middle-box text-center loginscreen animated fadeInDown">
                <div>
                    <div>
                        <h1 className="logo-name">
                            <img
                                srcSet="../img/gate_logo_light.png"
                                alt={localizationService.toLanguageString("LoginPage.Dodávky tovaru", "Dodávky tovaru")}
                                width="300"
                            />
                        </h1>
                    </div>
                    <h3>
                        <Localization messageKey={"LoginPage.Dodávky tovaru"} defaultMessage={"Dodávky tovaru"} />
                    </h3>
                    <p>
                        <Localization
                            messageKey={"LoginPage.Pre prihlásenie zadajte predajňu, užívateľské meno a heslo."}
                            defaultMessage={"Pre prihlásenie zadajte predajňu, užívateľské meno a heslo."}
                        />
                    </p>
                    {errorMessage && (
                        <div id="check-error" style={{ color: "#ed5565" }}>
                            {errorMessage}
                        </div>
                    )}
                    <Form
                        validate={(values) => this.onValidation(values)}
                        onSubmit={(values) => this.onSubmit(values)}
                        initialValues={this.state}
                        render={({ handleSubmit, submitting, valid }) => (
                            <form className="m-t" method="post" onSubmit={handleSubmit}>
                                <Field name="sklad">
                                    {({ input, meta }) => (
                                        <div className={"form-group" + (meta.error && meta.touched ? " has-error" : "")}>
                                            <select {...input} className="form-control">
                                                <option>{localizationService.toLanguageString("LoginPage.Vyberte predajňu...", "Vyberte predajňu...")}</option>
                                                {this.state.sklady.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.nazov}
                                                    </option>
                                                ))}
                                            </select>
                                            {meta.error && meta.touched && <div className="help-block">{meta.error}</div>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="username">
                                    {({ input, meta }) => (
                                        <div className={"form-group" + (meta.error && meta.touched ? " has-error" : "")}>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control"
                                                placeholder={localizationService.toLanguageString("LoginPage.Užívateľské meno", "Užívateľské meno")}
                                            />
                                            {meta.error && meta.touched && <div className="help-block">{meta.error}</div>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="password">
                                    {({ input, meta }) => (
                                        <div className={"form-group" + (meta.error && meta.touched ? " has-error" : "")}>
                                            <input
                                                {...input}
                                                type="password"
                                                className="form-control"
                                                placeholder={localizationService.toLanguageString("LoginPage.Heslo", "Heslo")}
                                            />
                                            {meta.error && meta.touched && <div className="help-block">{meta.error}</div>}
                                        </div>
                                    )}
                                </Field>
                                <button type="submit" disabled={submitting || !valid} className="btn btn-primary block full-width m-b login-button">
                                    <Localization messageKey={"LoginPage.Prihlásiť"} defaultMessage={"Prihlásiť"} />
                                </button>
                            </form>
                        )}
                    />
                    <p className="m-t">
                        <small>
                            <strong>Copyright</strong> tsium s.r.o. &copy; 2019
                        </small>
                    </p>
                </div>
            </div>
        );
    }
}

export default withRouter(Login);

Login.contextType = GlobalContext;

registerForLocalization(Login);



// WEBPACK FOOTER //
// ./src/components/views/Login.js